import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Select, DatePicker, Input, Table, Form, Modal, Radio, message, Upload, Steps, Row, Col, Spin } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../Dashboard/Darts/masterConfiguration/userManagement/userManagement.css";
import "antd/dist/reset.css";
import { Accounts_Query, Add_Multiple_Users, Current_Designation, Get_City, Get_States, GET_User_Details_User_Management, Role_Account_Query, Remove_User, Update_User, Bulk_Upload, Bulk_Upload_Sheet, Verify_Employee_Id, List_Gender_From_Role, List_Employement_Type_From_Role, Get_User_Users_In_Excel_For_Role, Get_User_Types, GET_PERFORMANCE_DATA_EXCEL, UPLOAD_PERFORMANCE_EXCEL, GET_User_Details_User_Management_For_RootAdmin, GET_MANAGER_WITH_FULLNAME_EMPID_LOCATION } from "../../../services/userAPI";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import BulkUploadFiles from "../../../Images/bulk-upload-files -added-icon.png";
import TextInputField from "../../../reusableField/TextInputField2";
import { validationRegexAlphaNumeric, validationRegexAmount, validationRegexMobileNo, validationRegexOnlyAlpha } from "../../../regex/regex";
import { Breadcrumb } from 'antd';
import SelectDropdown from "react-select"
import dayjs from 'dayjs';
import { Tabs } from "antd";
import PageBreadcrumb from '../../../reusableField/PageBreadcrumb';
import PaginationPrevious from "../../../Images/paginationPreviuosIcon.png";
import PaginationNext from "../../../Images/paginationNextIcon.png";
import { AgGridReact } from "ag-grid-react";
import ThresholdsConfiguration from "../../Dashboard/Darts/masterConfiguration/thresholdsConfiguration";
import ProfileImageUploader from "../../../components/profileImageUploader";
import UploadModal from "../../Dashboard/Darts/masterConfiguration/userManagement/uploadModal";
import AdminMastersConfiguration from "./adminMastersConfiguration";
import CustomNoRowsOverlay from "../../CustomNoRowsOverlay";
const { TabPane } = Tabs;

const AdminUserManagement = ({ index }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const roleId = location.state?.roleId;
    const accountId = location.state?.accountId;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(1000);
    const [paginationToken, setPaginationToken] = useState(null);
    const [touched, setTouched] = useState({})
    const [errors, setErrors] = useState({})
    const name = location.state?.name;
    const accountName = location.state?.accountName;
    const [showInitialLoading, setShowInitialLoading] = useState(true);
    const [isModalVisibleForPerformanceUpload, setIsModalVisibleForPerformanceUpload] = useState(false); // For performance upload
    const getActiveTabFromPath = () => {
        if (location.pathname.includes("masters-configuration")) return "masters-configuration";
        return "user-management";
    };
    const [activeTab, setActiveTab] = useState(getActiveTabFromPath());


    const { data: jobRoleData, loading: jobRoleLoading, error: jobRoleError } = useQuery(Role_Account_Query, {
        variables: { id: roleId, accountId: accountId },
        skip: !roleId, // Skip query if roleId is not available
        fetchPolicy: "network-only",
    });

    const [loginConfig, setLoginConfig] = useState({
        numberLogin: false,
        emailLogin: false,
    });

    useEffect(() => {
        if (jobRoleData?.getAllJobrole?.[0]) {
            setLoginConfig({
                numberLogin: jobRoleData.getAllJobrole[0].numberLogin,
                emailLogin: jobRoleData.getAllJobrole[0].emailLogin,
            });
        }
    }, [jobRoleData]);

    useEffect(() => {
        setActiveTab(getActiveTabFromPath());
    }, [location.pathname]);

    const handleNextToProductConfiguration = () => {
        if (activeTab === "masters-configuration") {
            navigate("/admin-masters-configuration", { state: { roleId, accountId, name, accountName } });
        }
    };

    const [roleIds, setRoleIds] = useState(() => {
        return localStorage.getItem("roleId") || location.state?.roleId || null;
    });

    const [accountIds, setAccountIds] = useState(() => {
        return localStorage.getItem("accountId") || location.state?.accountId || null;
    });

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [roleOptions, setRoleOptions] = useState([])

    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [cityOptions, setCityOptions] = useState([])

    const [selectedDesignation, setSelectedDesignation] = useState(null);

    const [step, setStep] = useState(0);
    const [step1, setStep1] = useState(0);

    const handleNext = (e) => {
        // Prevent default form submission behavior
        e.preventDefault();
        e.stopPropagation();

        // Create a copy of the touched state
        const newTouched = { ...touched };

        const fieldsToValidate = [
            "employeeid",
            "firstName",
            "lastName",
            "gender",
            "dateOfBirth",
            "highestEducationQualification",
            "previousEmployer",
            "previousExperience",
        ];

        if (loginConfig.emailLogin && !loginConfig.numberLogin) {
            fieldsToValidate.push("employeeMailId");
        }
        if (loginConfig.numberLogin && !loginConfig.emailLogin) {
            fieldsToValidate.push("phoneNumber");
        }

        // Mark all fields as touched to trigger validation
        fieldsToValidate.forEach(field => {
            newTouched[field] = true;
        });

        setTouched(newTouched);

        // Validate form data
        const stepErrors = validateFirstStep(formData);
        const hasErrors = Object.keys(stepErrors).length > 0;

        // Set errors
        setErrors(prevErrors => ({ ...prevErrors, ...stepErrors }));

        if (!hasErrors) {
            setStep(1);
        }
    };

    const validateFirstStep = (data) => {
        const errors = {};
        if (!data.employeeid?.trim()) errors.employeeid = "Employee ID is required";
        if (loginConfig.emailLogin && !loginConfig.numberLogin) {
            if (!data.employeeMailId?.trim()) {
                errors.employeeMailId = "Employee Mail ID is required";
            } else if (!emailRegex.test(data.employeeMailId)) {
                errors.employeeMailId = "Invalid email format";
            }
        }
        if (loginConfig.numberLogin && !loginConfig.emailLogin) {
            if (!data.phoneNumber?.trim()) {
                errors.phoneNumber = "Phone number is required";
            } else if (!validationRegexMobileNo.test(data.phoneNumber)) {
                errors.phoneNumber = "Invalid phone number format";
            } else if (data.phoneNumber.trim().length !== 10) {
                errors.phoneNumber = "Phone number must be exactly 10 digits";
            }
        } else if (data.phoneNumber?.trim() && data.phoneNumber.trim().length !== 10) {
            errors.phoneNumber = "Phone number must be exactly 10 digits";
        }
        if (!data.firstName?.trim()) errors.firstName = "First name is required";
        if (!data.lastName?.trim()) errors.lastName = "Last name is required";
        // if (!data.phoneNumber?.trim()) errors.phoneNumber = "Phone Number is required";
        if (!data.dateOfBirth) errors.dateOfBirth = "Date of birth is required";
        if (!data.gender) errors.gender = "Gender is required";

        return errors;
    };

    const toggleSelectionMode = () => {
        setSelectionMode(!selectionMode);
        if (selectionMode) {
            setSelectedUsers([]);
        }
    };

    const [formData, setFormData] = useState({
        fullTimeConsultant: "",
        currentBranch: "",
        employeeIdOfManager: "",
        nameOfManager: "",
        clientImage: "",
        imageUrl: "",
        mainLogoUrl: "",
        id: "",
        userId: null,
        dateOfJoining: null,
        currentDesignation: "",
        state: "",
        city: "",
        zone: "",
        dateOfReporting: null,
        employeeid: "",
        employeeMailId: "",
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: null,
        highestEducationQualification: "",
        previousEmployer: "",
        previousExperience: "",
        phoneNumber: "",
    });

    const [addUsers, { loading: addUsersLoading, error: addUsersError, data: addUsersData }] = useMutation(Add_Multiple_Users);

    const [formDataList, setFormDataList] = useState([
        {
            fullTimeConsultant: null,
            dateOfJoining: null,
            currentDesignation: "",
            currentBranch: "",
            state: "",
            city: "",
            zone: "",
            employeeIdOfManager: "",
            dateOfReporting: null,
            nameOfManager: "",
        }
    ])
    const [selectedDate, setSelectedDate] = useState(null);
    const [cursor, setCursor] = useState(null);
    const { loading, error, data, refetch } = useQuery(GET_User_Details_User_Management_For_RootAdmin, {
        variables: {
            roleId: roleId || "",
            pagingCriteria: {
                cursor: cursor,
                limit: pageSize,
                sortOrder: "asc",
                sortByField: "name"
            }
        },
        skip: !roleId,
        fetchPolicy: "network-only", // Ensures we always get fresh data
    });

    useEffect(() => {
        if (data && data.getUsersForAccount) {
            setShowInitialLoading(true);
            const timer = setTimeout(() => {
                setShowInitialLoading(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [data]);
    // const users = data.getUsersForAccount.data;
    const pageMeta = data?.getUsersForAccount?.pageMeta;

    const totalCount = data?.getUsersForAccount?.pageMeta?.totalCount || 0;
    const totalPages = Math.ceil(totalCount / pageSize);
    const handlePrevious = () => {
        if (pageMeta?.hasPreviousPage) {
            setCursor(pageMeta.previousPage);
            setCurrentPage((prev) => Math.max(prev - 1, 1));
        }
    };

    const handleNextt = () => {
        if (pageMeta?.hasNextPage) {
            setCursor(pageMeta.nextPage);
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
        }
    };

    // Add this useEffect to refetch data when pagination token changes
    useEffect(() => {
        if (roleId) {
            refetch({
                roleId,
                filterByName: searchTerm,
                joiningDateFilter: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
                pagingCriteria: {
                    cursor: paginationToken,
                    limit: pageSize,
                    sortOrder: "asc",
                    sortByField: "name"
                },
            });
        }
    }, [paginationToken, pageSize, searchTerm, selectedDate, roleId]);

    useEffect(() => {
        if (searchTerm !== "") {
            refetch({
                roleId: roleId,
                filterByName: searchTerm,
                joiningDateFilter: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
                pagingCriteria: {
                    cursor: null,
                    limit: pageSize
                }
            });
        }
    }, [searchTerm]);
    const [form] = Form.useForm();

    const tableData = useMemo(() => {
        return (
            data?.getUsersForAccount?.data?.map((user, index) => ({
                key: user.UserId,
                UserId: user.id || null,
                id: user.employeeId || "",
                // name: user.surname + " " + user.name || "Unnamed User",
                name: user.fullname || "",
                employeeMailId: user.email || "",
                gender: user.gender || "",
                genderId: user.genderId || null,
                joiningDate: user.joiningDate || "",
                designation: user.designation || "",
                designationId: user.designationId || null,
                surname: user.surname || "",
                dateOfBirth: user.dateOfBirth || "",
                city: user.city || "",
                branch: user.branch || "",
                role: user.role || "",
                phoneNumber: user.phoneNumber || "",
                address: user.address || "",
                state: user.state || "",
                zone: user.zone || "",
                highestEducationQualification: user.highestEducationQualification || "",
                previousEmployer: user.previousEmployer || "",
                previousExperience: user.previousExperience ? Number(user.previousExperience) : 0,
                profileActivated: user.profileActivated || false,
                roleId: user.roleId || null,
                roleStartDate: user.roleStartDate || "",
                accountId: user.accountId || null,
                accountName: user.accountName || "",
                reportingDate: user.reportingDate || "",
                employeeId: user.employeeId || "",
                employeeIds: user.reporting?.employeeId || "",
                employeeName: user.reporting?.name || "",
                stateName: user.stateName || "",
                cityName: user.cityName || "",
                employeeType: user.employeeType || "",
                employeeTypeId: user.employeeTypeId || null,
                numberOfAssociates: user.numberOfAssociates || 0,
                numberOfManagers: user.numberOfManagers || 0,
                status: user.status || 0,
                userType: user.userType?.userType || "",
            })) || []
        );
    }, [data?.getUsersForAccount?.data]);

    const handleView = (userId) => {
        navigate(`/admin-user/${userId}`, {
            state: {
                name: name || "",
                accountName: accountName || "",
                roleId: roleId || null,
                accountId: accountId || null,
            },
        });
    };

    // Add to existing state
    const gridApiRef = useRef(null);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridReady, setGridReady] = useState(false);
    const [displayedRowCount, setDisplayedRowCount] = useState(null);

    const [getUsersInExcel, { loading: exportLoading, data: exportData, error: exportError }] = useLazyQuery(Get_User_Users_In_Excel_For_Role, {
        fetchPolicy: "network-only",
    });

    const handleExport = async () => {
        try {
            const api = gridApiRef.current;
            let displayedRows = [];

            // Helper to get the display value for a field (must match valueGetters in columnDefs)
            const getDisplayValue = (row, field) => {
                if (field === "joiningDate") {
                    if (!row.joiningDate) return "";
                    const date = new Date(row.joiningDate);
                    if (isNaN(date)) return row.joiningDate;
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                }
                if (field === "status") {
                    return row.profileActivated === true ? "Active" : "Inactive";
                }
                const val = row[field];
                return val === null || val === undefined ? "" : String(val);
            };

            if (api) {
                // Read the active filter model from the grid
                const filterModel = api.getFilterModel();

                if (filterModel && Object.keys(filterModel).length > 0) {
                    // Filters are active — apply them to tableData manually
                    displayedRows = [...tableData];
                    Object.keys(filterModel).forEach(field => {
                        const filter = filterModel[field];
                        if (filter && filter.filter) {
                            const filterValue = filter.filter.toLowerCase();
                            displayedRows = displayedRows.filter(row => {
                                const cellValue = getDisplayValue(row, field);
                                return cellValue.toLowerCase().includes(filterValue);
                            });
                        }
                    });
                } else {
                    // No filters active — export all current tableData
                    displayedRows = [...tableData];
                }
            } else {
                // Grid not ready — fallback to full tableData
                displayedRows = [...tableData];
            }

            if (displayedRows.length === 0) {
                message.warning("No data available to export.");
                return;
            }

            // Define the columns to export with optional value formatter
            const exportColumns = [
                { field: "id", header: "Employee ID" },
                { field: "name", header: "Name" },
                { field: "employeeMailId", header: "Email" },
                { field: "phoneNumber", header: "Phone" },
                { field: "designation", header: "Designation" },
                {
                    field: "joiningDate", header: "Date of Joining", formatter: (val) => {
                        if (!val) return "";
                        const date = new Date(val);
                        if (isNaN(date)) return val;
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        return `${day}/${month}/${year}`;
                    }
                },
                { field: "cityName", header: "City" },
                { field: "branch", header: "Branch" },
                { field: "userType", header: "Login Type" },
                { field: "profileActivated", header: "App Active/Inactive", formatter: (val) => val === true ? "Active" : "Inactive" },
            ];

            // Convert data to CSV format
            const csvHeader = exportColumns.map(col => col.header).join(",");
            const csvRows = displayedRows.map(row => {
                return exportColumns.map(col => {
                    let value = col.formatter ? col.formatter(row[col.field]) : (row[col.field] || "");
                    // Escape quotes and wrap in quotes if contains comma
                    if (typeof value === "string") {
                        value = value.replace(/"/g, '""');
                        if (value.includes(",") || value.includes('"') || value.includes("\n")) {
                            value = `"${value}"`;
                        }
                    }
                    return value;
                }).join(",");
            });

            const csvContent = [csvHeader, ...csvRows].join("\n");

            // Create blob and download
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `user_management_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.success(`Export completed successfully! (${displayedRows.length} records exported)`);
        } catch (error) {
            console.error("Error exporting data:", error);
            message.error("An error occurred while exporting data.");
        }
    };

    const handleExportClick = () => {
        handleExport();
    };

    // Column Definitions
    const columnDefs = useMemo(() => [
        {
            headerName: "Employee ID",
            headerTooltip: "Employee ID",
            field: "id",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
        },
        {
            headerName: "Name",
            headerTooltip: "Name",
            field: "name",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            cellRenderer: (params) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => handleView(params.data.UserId)}
                >
                    {params.value}
                </span>
            ),
        },
        {
            headerName: "Email",
            headerTooltip: "Email",
            field: "employeeMailId", // Changed from "email" to "employeeMailId" to match tableData
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => params.data?.employeeMailId || "", // Fallback if email is missing
        },
        { headerName: "Phone", headerTooltip: "Phone", field: "phoneNumber", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        { headerName: "Designation", headerTooltip: "Designation", field: "designation", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        {
            headerName: "Date of Joining",
            headerTooltip: "Date of Joining",
            field: "joiningDate",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => {
                if (!params.data?.joiningDate) return "";
                const date = new Date(params.data.joiningDate);
                if (isNaN(date)) return params.data.joiningDate;
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        { headerName: "City", headerTooltip: "City", field: "cityName", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        { headerName: "Branch", headerTooltip: "Branch", field: "branch", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        {
            headerName: "Login Type",
            headerTooltip: "Login Type",
            field: "userType",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => params.data?.userType || "",
        },
        {
            headerName: "App Active/Inactive",
            headerTooltip: "App Active/Inactive",
            field: "status",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => {
                const profileActivated = params.data?.profileActivated;
                return profileActivated === true ? "Active" : "Inactive";
            },
        }
    ], [selectedUsers, tableData, gridApi]);

    // Default Column Definitions
    const defaultColDef = useMemo(() => ({
        flex: 1,
        minWidth: 100,
        resizable: true,
        sortable: true,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        cellStyle: { padding: "10px" },
        tooltipValueGetter: (params) => params.value,
    }), []);

    // Grid Ready Handler
    const onGridReady = (params) => {
        gridApiRef.current = params.api;
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        setGridReady(true);
    };

    const onFilterChanged = (params) => {
        if (params?.api) {
            const isFilterActive = params.api.isAnyFilterPresent();
            if (isFilterActive) {
                const filterModel = params.api.getFilterModel();
                let filteredData = [...tableData];

                const getDisplayVal = (row, field) => {
                    if (field === "joiningDate") {
                        if (!row.joiningDate) return "";
                        const date = new Date(row.joiningDate);
                        if (isNaN(date)) return row.joiningDate;
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        return `${day}/${month}/${year}`;
                    }
                    if (field === "status") {
                        return row.profileActivated === true ? "Active" : "Inactive";
                    }
                    const val = row[field];
                    return val === null || val === undefined ? "" : String(val);
                };

                Object.keys(filterModel).forEach(field => {
                    const filter = filterModel[field];
                    if (filter && filter.filter) {
                        const filterValue = filter.filter.toLowerCase();
                        filteredData = filteredData.filter(row => {
                            const cellValue = getDisplayVal(row, field);
                            return cellValue.toLowerCase().includes(filterValue);
                        });
                    }
                });

                setDisplayedRowCount(filteredData.length);
                if (filteredData.length === 0) {
                    params.api.showNoRowsOverlay();
                } else {
                    params.api.hideOverlay();
                }
            } else {
                setDisplayedRowCount(null);
                params.api.hideOverlay();
            }
        }
    };

    const noRowsOverlayComponent = () => {
        return <CustomNoRowsOverlay message="No users found" />;
    };

    const onSelectionChanged = () => {
        if (gridApi) {
            const selectedRows = gridApi.getSelectedRows();
            setSelectedUsers(selectedRows.map(row => row.key));
        }
    };

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = (e) => {
        if (e) e.preventDefault();
        setStep(0);
        setStep1(0);
        setIsModalVisible(false);
        // Reset Ant Design form
        form.resetFields();
        // Reset form data
        setFormData({
            fullTimeConsultant: "",
            currentBranch: "",
            employeeIdOfManager: "",
            nameOfManager: "",
            clientImage: "",
            imageUrl: "",
            mainLogoUrl: "",
            id: "",
            userId: null,
            dateOfJoining: null,
            currentDesignation: "",
            state: "",
            city: "",
            zone: "",
            dateOfReporting: null,
            employeeid: "",
            employeeMailId: "",
            firstName: "",
            lastName: "",
            gender: "",
            dateOfBirth: null,
            highestEducationQualification: "",
            previousEmployer: "",
            previousExperience: "",
            phoneNumber: "",
        });

        // Reset select dropdowns state variables
        setSelectedCompany(null);
        setSelectedRole(null);
        setSelectedDesignation(null);
        setSelectedState(null);
        setSelectedCity(null);
        setManagerName("No Manager");
        setRoleOptions([]);
        // Reset form data list if using it
        setFormDataList([
            {
                fullTimeConsultant: "",
                dateOfJoining: null,
                currentDesignation: "",
                currentBranch: "",
                state: "",
                city: "",
                zone: "",
                employeeIdOfManager: "",
                dateOfReporting: null,
                nameOfManager: "No Manager",
            }
        ]);

        // Reset validation state
        setTouched({});
        setErrors({});
    };

    const handleInputChange = (e, field, index) => {
        const { name, value } = e.target || e;
        const fieldName = field || name;
        // Ensure correct data type for previousExperience
        const updatedValue = fieldName === "previousExperience" && value !== ""
            ? parseInt(value, 10)
            : value;

        // Update form data
        if (index !== undefined) {
            setFormDataList(prevList =>
                prevList.map((item, idx) =>
                    idx === index ? { ...item, [fieldName]: updatedValue } : item
                )
            );
        } else {
            setFormData(prev => ({
                ...prev,
                [fieldName]: updatedValue
            }));
        }

        setTouched(prev => ({
            ...prev,
            [index !== undefined ? `${index}-${fieldName}` : fieldName]: true
        }));

        // Email validation
        if (fieldName === "employeeMailId") {
            if (!value.trim()) {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: ""
                }));
            } else if (!emailRegex.test(value)) {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: "Invalid email format"
                }));
            } else {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: undefined
                }));
            }
        } else {
            // Clear errors for other fields
            if (index !== undefined) {
                setErrors(prev => ({
                    ...prev,
                    [`${index}-${fieldName}`]: undefined
                }));
            } else {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: undefined
                }));
            }
        }
        // Mark as touched
        setTouched(prev => ({
            ...prev,
            [index !== undefined ? `${index}-${fieldName}` : fieldName]: true
        }));
    };

    const removeUserFields = (index) => {
        setFormDataList(formDataList.filter((_, i) => i !== index));
    };

    const handleDateChange = (name, date) => {
        // Convert the date to a normal date string (YYYY-MM-DD format)
        const normalDate = date ? date.format('YYYY-MM-DD') : null;
        setFormData((prevData) => ({
            ...prevData,
            [name]: normalDate, // Use the normalized date string
        }));

        setTouched((prevTouched) => ({
            ...prevTouched,
            [name]: true,
        }));

        // Clear the error for this field if it has a value
        if (normalDate) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [name]: undefined
            }));
        }
    };

    const handleListDateChange = (index, field, date) => {
        setFormDataList(prevList =>
            prevList.map((item, idx) =>
                idx === index ? { ...item, [field]: date } : item // Keep as Date object
            )
        );
    };

    const handleSubmit = async (e) => {
        const formValues = form.getFieldsValue(true);
        const formatDate = (dateValue) => {
            if (!dateValue) return null;

            try {
                const date = new Date(dateValue);
                if (isNaN(date.getTime())) return null;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            } catch (error) {
                console.error("Invalid date format:", dateValue);
                return null;
            }
        };

        localStorage.setItem("roleId", roleId);
        localStorage.setItem("accountId", accountId);

        // Map your form data to the expected API structure
        const userData = formDataList.map((item, index) => {
            // Find gender ID based on selected gender name
            const selectedGender = genderOptions.find(option => option.value === (formData.gender || item.gender));
            const selectedEmployementTypeId = employementOptions.find(option => option.value === (formData.fullTimeConsultant || item.fullTimeConsultant));
            const selectedUserType = userTypesOptions.find(option => option.value === (formData.userType || item.userType));
            const genderId = selectedGender ? selectedGender.id : null; // Ensure genderId is sent

            return {
                accountId: accountId || null,
                currentRoleId: roleId || null,
                employeeId: formData.employeeid || item.employeeid || "",
                firstName: formData.firstName || item.firstName || "",
                lastName: formData.lastName || item.lastName || "",
                email: formData.employeeMailId || item.employeeMailId || "",

                genderId: selectedGender ? selectedGender.value : null,  // Send ID
                employeeTypeId: selectedEmployementTypeId ? selectedEmployementTypeId.value : null,  // Send ID

                dateOfBirth: (formData.dateOfBirth || item.dateOfBirth) ? formatDate(formData.dateOfBirth || item.dateOfBirth) : "",
                joiningDate: (formData.dateOfJoining || item.dateOfJoining) ? formatDate(formData.dateOfJoining || item.dateOfJoining) : "",
                validFrom: (formData.dateOfReporting || item.dateOfReporting) ? formatDate(formData.dateOfReporting || item.dateOfReporting) : null,

                higestEducationQualification: formData.highestEducationQualification || item.highestEducationQualification || "",
                previousEmployer: formData.previousEmployer || item.previousEmployer || "",
                managerEmployeeId: formData.employeeIdOfManager || item.employeeIdOfManager || null,
                designation: selectedDesignation?.value ? (selectedDesignation.value) : "Unknown",
                state: selectedState?.value ? (selectedState.value) : "Unknown",
                city: selectedCity?.value ? (selectedCity.value) : "Unknown",

                zone: item.zone?.value || item.zone || "Unknown",
                location: item.location || "Unknown",
                userId: null,
                branch: item.currentBranch || "Unknown",
                previousExperience: (formData.previousExperience || item.previousExperience)
                    ? parseInt(formData.previousExperience || item.previousExperience, 10)
                    : 0,
                userTypeId: selectedUserType?.value ? (selectedUserType.value) : null,
            };
        });

        try {
            const response = await addUsers({ variables: { data: userData } });
            const result = response?.data?.addMultipleUsers;
            const success = result?.success;
            const userErrors = result?.data || [];

            if (success) {
                message.success("Users added successfully!");
                handleCancel(false); // Assuming you have a state to control modal visibility

                // Reset form fields (optional)
                form.resetFields();
                await refetch();
                setRoleIds(localStorage.getItem("roleId"));
                setAccountIds(localStorage.getItem("accountId"));
                // fetchDesignations({ variables: { jobroleId: Number(localStorage.getItem("roleId")) } });
            } else {
                userErrors.forEach((error) => {
                    if (error?.message) {
                        message.error(error.message); // e.g., "employee id already exists"
                    }
                });

                console.error("User addition failed:", response.data);
            }
        } catch (error) {
            console.error("GraphQL Error:", error);
            message.error("Failed to add users due to a system error.");
        }
    }

    const userTypeOptions = [
        { label: "North", value: "north" },
        { label: "South", value: "south" },
        { label: "East", value: "east" },
        { label: "West", value: "west" }
    ];

    const handleDesignationChange = (selectedOption) => {
        setSelectedDesignation(selectedOption);

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.currentDesignation; // Clears the error dynamically
            return newErrors;
        });

        setTouched(prevTouched => ({
            ...prevTouched,
            currentDesignation: true, // Mark as touched
        }));
    };

    const handleZoneChange = (selectedOption, index) => {
        setFormDataList(prevList =>
            prevList.map((item, idx) =>
                idx === index ? { ...item, zone: selectedOption } : item
            )
        );

        form.setFieldsValue({
            [index]: {
                ...form.getFieldValue(index),
                zone: selectedOption || ""
            }
        });

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${index}-zone`]; // Remove error dynamically
            return newErrors;
        });

        setTouched(prevTouched => ({
            ...prevTouched,
            [`${index}-zone`]: true, // Mark as touched per index
        }));
    }

    const [isModalVisibleForUpload, setIsModalVisibleForUpload] = useState(false);
    const showModalForUpload = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsModalVisibleForUpload(true);
    }
    const handleCancelUpload = () => setIsModalVisibleForUpload(false);

    const [bulkUploadUsers, { bulkUploadloading, bulkUploaderror, data: bulkUploadData }] = useMutation(Bulk_Upload);
    const [file, setFile] = useState(null);

    const handleUpload = async () => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("accountId", accountId || ""); // Ensure company ID is sent
        formData.append("currentRoleId", roleId || "");

        try {
            const response = await bulkUploadUsers({
                variables: {
                    accountId: accountId,
                    roleId: roleId,
                    document: file,
                },
            });
            if (response?.data?.bulkUploadUsers?.success) {
                message.success("File uploaded successfully!");
                navigate("/bulk-leads-result", {
                    state: {
                        data: response.data,
                        fileName: file.name,
                        accountId,
                        roleId,
                        accountName,
                        name,
                    },
                });
                setFile(null); // Reset file after upload
                setSelectedCompany(null);
                handleCancelUpload(); // Close modal after successful upload
            } else {
                message.error(response?.data?.bulkUploadUsers?.message || "File upload failed");
            }
        } catch (err) {
            console.error("Upload error:", err);
            message.error("File upload failed. Please try again.");
        }
    };

    const { data: stateData, stateLoading, stateError } = useQuery(Get_States);
    const stateOptions = stateData?.getStates?.map((state) => ({
        value: state.id,
        label: state.stateName,
    })) || [];

    const { companyloading, companyerror, data: companyName } = useQuery(Accounts_Query);
    const companyOptions = companyName?.allUserAccount?.map((company) => ({
        value: company.id,
        label: company.name,
    })) || [];

    const [fetchCities, { loading: citiesLoading, error: citiesError }] = useLazyQuery(Get_City, {
        fetchPolicy: "network-only", // Ensures fresh data on every request
        onCompleted: (data) => {
            const roles = data?.getCity?.map((city) => ({
                value: city.id,
                label: city.cityName,
            })) || [];
            setCityOptions(roles);
        },
    });

    const handleUserTypeChange = (selectedOption, index) => {
        setFormDataList(prevList =>
            prevList.map((item, idx) =>
                idx === index ? { ...item, userType: selectedOption.value } : item
            )
        );
        form.setFieldsValue({
            [index]: {
                ...form.getFieldValue(index),
                userType: selectedOption || ""
            }
        });
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${index}-userType`];
            return newErrors;
        });
        setTouched(prevTouched => ({
            ...prevTouched,
            [`${index}-userType`]: true,
        }));
    };

    const { loading: userTypesLoading, error: userTypesError, data: userTypesData } = useQuery(Get_User_Types, {
        fetchPolicy: "network-only",
    });

    const userTypesOptions = userTypesData?.getUserTypes?.map((type) => ({
        value: type.id,
        label: type.userType,
    })) || [];

    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        setSelectedCity(null);
        setCityOptions([]); // Reset roles when company changes

        if (selectedOption?.value) {
            fetchCities({ variables: { stateId: parseInt(selectedOption.value, 10) } });
        }

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.state;
            return newErrors;
        });
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.city;
            return newErrors;
        });
    };

    useEffect(() => {
        if (location.state?.roleId && location.state?.roleId !== roleIds) {
            setRoleIds(location.state.roleId);
            localStorage.setItem("roleId", location.state.roleId);
        }

        if (location.state?.accountId && location.state?.accountId !== accountIds) {
            setAccountIds(location.state.accountId);
            localStorage.setItem("accountId", location.state.accountId);
        }
    }, [location.state?.roleId, location.state?.accountId]);

    const handleDrop = (info) => {
        info.preventDefault();
        if (info.file) {
            setFile(info.file);
        }
    };

    const [getBulkUploadExcel, { loading: downloadLoading, data: downloadData, error: downloadError }] = useLazyQuery(Bulk_Upload_Sheet);

    const handleDownload = () => {
        getBulkUploadExcel();
    };

    useEffect(() => {
        if (downloadData && downloadData.getBulkUploadExcel) {

            // Get the URL from the response
            const fileUrl = downloadData.getBulkUploadExcel;

            // Create an anchor element to trigger the download
            const a = document.createElement('a');
            a.href = fileUrl;
            a.download = 'Bulk_Upload_Sheet.xlsx';
            a.style.display = 'none'; // Hide the element
            document.body.appendChild(a);

            // Trigger the click event
            setTimeout(() => {
                a.click();
                // Clean up
                document.body.removeChild(a);
            }, 100);
        }

        if (downloadError) {
            console.error("API Error:", downloadError);
        }
    }, [downloadData, downloadError]);

    const [managerName, setManagerName] = useState("No Manager");
    const [selectedManagerEmployeeId, setSelectedManagerEmployeeId] = useState("");
    const [managerSearchTerm, setManagerSearchTerm] = useState("");


    const { data: managersListData, loading: managersListLoading } = useQuery(GET_MANAGER_WITH_FULLNAME_EMPID_LOCATION, {
        variables: {
            roleId: parseInt(roleId) || 0,
            searchTerm: managerSearchTerm || "",
            pagingCriteria: {
                limit: 50,
                cursor: null,
                sortByField: "name",
                sortOrder: "asc",
            },
        },
        skip: !roleId,
        fetchPolicy: "network-only",
    });

    // Build manager options for dropdown - show "Full Name + Employee ID + Location"
    const managerOptions = useMemo(() => {
        if (!managersListData?.getManagerWithFullnameEmpidLocation?.data) return [];
        return managersListData.getManagerWithFullnameEmpidLocation.data.map((manager) => {
            const fullName = [manager.name, manager.surname].filter(Boolean).join(' ');
            const location = manager.location || manager.cityName || '';
            const labelParts = [fullName, manager.employeeId, location].filter(Boolean);
            return {
                value: manager.id,
                label: labelParts.join(' | '),
                employeeId: manager.employeeId,
                name: fullName,
                location: location,
            };
        });
    }, [managersListData]);

    // Handle manager selection from dropdown
    const handleManagerSelect = (selectedOption, index) => {
        if (selectedOption) {
            setSelectedManagerEmployeeId(selectedOption.employeeId || "");
            setManagerName(selectedOption.name || "No Manager");
            // Update form data with the manager's employee ID
            const updatedFormDataList = [...formDataList];
            updatedFormDataList[index] = {
                ...updatedFormDataList[index],
                employeeIdOfManager: selectedOption.employeeId,
            };
            setFormDataList(updatedFormDataList);
        } else {
            setSelectedManagerEmployeeId("");
            setManagerName("No Manager");
            // Clear employeeIdOfManager when manager is removed
            const updatedFormDataList = [...formDataList];
            updatedFormDataList[index] = {
                ...updatedFormDataList[index],
                employeeIdOfManager: null,
            };
            setFormDataList(updatedFormDataList);
        }
    };

    const [fetchManager, { data: employeeIdData, loading: employeeIdLoading, error: employeeIdError }] = useLazyQuery(Verify_Employee_Id);
    const handleEmployeeIdChange = (e, index) => {
        const employeeId = e.target.value;
        handleInputChange(e, "employeeIdOfManager", index);

        if (employeeId.length >= 3) { // Fetch only after 3+ characters
            fetchManager({ variables: { employeeId } });
        }
    };

    const handleImageUpdate = (newImageUrl) => {
        // Only update if needed for UserManagement (e.g., current user preview)
        // Avoid propagating to table area
    };

    useEffect(() => {
        if (employeeIdData?.verifyEmployeeId) {
            // Set the manager's name in state
            const managerName = employeeIdData.verifyEmployeeId.name || "No Manager";
            setManagerName(managerName);  // Update state
        } else {
            setManagerName("No Manager");
        }
    }, [employeeIdData]);  // Dependency array - rerun whenever employeeIdData changes

    const handleDiscardClick = () => {
        navigate("/admin-home");
    };

    const { loading: genderLoading, error: genderError, data: genderData } = useQuery(List_Gender_From_Role, {
        variables: { jobroleId: roleId }, // Ensure roleId is correctly defined
    });

    // Check if genderData exists before mapping
    const genderOptions = genderData?.listGenderFromRole
        ? genderData.listGenderFromRole.map((gender) => ({
            value: gender.id,
            label: gender.name,
        }))
        : [];


    const { loading: employementLoading, error: employementError, data: employementData } = useQuery(
        List_Employement_Type_From_Role,
        { variables: { jobRoleId: roleId } } // Ensure roleId is defined
    );

    // Convert API response into dropdown options
    const employementOptions = employementData?.listEmployementTypeFromRole?.map((type) => ({
        value: type.id,   // Store the ID
        label: type.name, // Display the name
    })) || [];

    const { loading: designationsLoading, error: designationsError, data: designationsData } = useQuery(
        Current_Designation,
        { variables: { jobroleId: roleId } } // Ensure roleId is defined
    );

    // Convert API response into dropdown options
    const designationOptions = designationsData?.getDesignationsJobroleid?.map((type) => ({
        value: type.id,   // Store the ID
        label: type.designation, // Display the name
    })) || [];


    const handleBack = () => {
        navigate("/admin-home"); // This will navigate back to the previous page
    }

    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;

    const handleBackToViewRole = () => {
        // Use existing roleId and accountName from location.state, with fallbacks
        const safeRoleId = roleId || location.state?.roleId;
        const safeAccountName = accountName || location.state?.accountName;

        navigate("/admin-view-role", {
            state: {
                roleId: safeRoleId,
                accountId: accountId || location.state?.accountId,
                accountName: safeAccountName,
                name: name || location.state?.name,
                dartsNeeded: dartsNeeded || location.state?.dartsNeeded,
                clanNeeded: clanNeeded || location.state?.clanNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                dartsFormNeeded: dartsFormNeeded || location.state?.dartsFormNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                pocName: pocName || location.state?.pocName,
                pocEmail: pocEmail || location.state?.pocEmail,
                pocNumber: pocNumber || location.state?.pocNumber,
                numberLogin: numberLogin || location.state?.numberLogin,
                emailLogin: emailLogin || location.state?.emailLogin,
                mandatoryTimeDistribution: mandatoryTimeDistribution || location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays || location.state?.targetEditDays,
                inputEditDays: inputEditDays || location.state?.inputEditDays,
            },
        });
    };

    const [getPerformanceDataExcel, { loading: performanceDataLoading, data: performanceData, error: performanceDataError }] = useLazyQuery(GET_PERFORMANCE_DATA_EXCEL, {
        fetchPolicy: "network-only",
    });

    const handleDownloadPerformanceData = async () => {
        if (!accountId || !roleId) {
            message.error("Account ID or Role ID is missing. Cannot download performance data.");
            return;
        }

        try {
            const { data } = await getPerformanceDataExcel({
                variables: {
                    accountId: Number(accountId),
                    jobroleId: Number(roleId),
                },
            });

            if (data?.getPerformanceDataExcel) {
                const fileUrl = data.getPerformanceDataExcel;
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = `performance_data_${accountId}_${roleId}_${new Date().toISOString().split('T')[0]}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                message.success("Performance data downloaded successfully!");
            } else {
                message.error("Failed to retrieve performance data.");
            }
        } catch (error) {
            console.error("Error downloading performance data:", error);
            message.error("An error occurred while downloading performance data.");
        }
    };

    const [bulkUploadPerformance, { loading: performanceUploadLoading, error: performanceUploadError, data: performanceUploadData }] = useMutation(UPLOAD_PERFORMANCE_EXCEL); // Replace `Bulk_Upload` with `Bulk_Upload_Performance` if you have a specific mutation

    // Show performance upload modal
    const showModalForPerformanceUpload = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsModalVisibleForPerformanceUpload(true);
    };

    // Cancel performance upload modal
    const handleCancelPerformanceUpload = () => {
        setIsModalVisibleForPerformanceUpload(false);
    };

    // Handle success for performance upload
    const handlePerformanceUploadSuccess = (data, fileName) => {
        if (data?.uploadPerformanceExcel?.success) {
            // message.success("Performance data uploaded successfully!");
            navigate("/admin-user-management", {
                state: {
                    data: data.uploadPerformanceExcel.data,
                    fileName: fileName,
                    success: true,
                    roleId,
                    accountId,
                    name,
                    accountName,
                },
            });
        } else {
            // message.error("Performance data upload failed. Check the error file for details.");
            navigate("/admin-user-management", {
                state: {
                    data: null,
                    fileName: fileName,
                    success: false,
                    errorFileUrl: data?.uploadPerformanceExcel?.message,
                    roleId,
                    accountId,
                    name,
                    accountName,
                },
            });
        }
        setIsModalVisibleForPerformanceUpload(false);
    };

    return (
        <div className="user-management-container">
            <PageBreadcrumb homePath="/admin" onBack={handleBack}>

                <span onClick={handleBack} style={{ cursor: 'pointer' }}>{accountName}</span>
                <span>&gt;</span>
                <span onClick={handleBackToViewRole} style={{ cursor: 'pointer' }}>{name}</span>
                <span>&gt;</span>
                <span style={{ fontWeight: 'bold' }}>User management</span>
            </PageBreadcrumb>

            <Tabs activeKey={activeTab} onChange={(key) => {
                if (key === "masters-configuration") {
                    navigate("/admin-masters-configuration", { state: { roleId, accountId, name, accountName } });
                } else {
                    navigate("/admin-user-management", { state: { roleId, accountId, name, accountName } });
                }
            }} centered>
                <TabPane style={{ color: "red" }} tab="Masters Configuration" key="masters-configuration">
                    <AdminMastersConfiguration
                        roleId={roleId}
                        accountId={accountId}
                        name={name}
                        accountName={accountName}
                        onSaveSuccess={handleNextToProductConfiguration}
                    />
                    <ThresholdsConfiguration onSaveSuccess={handleNextToProductConfiguration} />
                </TabPane>
                <TabPane tab="User Management" key="user-management">
                    <>
                        {activeTab === "user-management" && (
                            <div>
                                <div className="search-container-user-management-download-upload">
                                    <div className="button-group-user-management-download-upload">
                                        <button
                                            className="download-user-btn"
                                            onClick={handleDownloadPerformanceData}
                                            disabled={performanceDataLoading}
                                        >
                                            {performanceDataLoading ? "Performance Downloading..." : "Performance Download"}
                                        </button>

                                        <button
                                            className="upload-user-btn"
                                            onClick={showModalForPerformanceUpload} // Updated to open performance upload modal
                                        >
                                            Performance Upload
                                        </button>
                                    </div>
                                </div>
                                <div className="search-container-user-management">

                                    <div className="button-group-user-management">
                                        <button className="select-user-btn" onClick={handleExportClick}>
                                            Export CSV/XLS
                                        </button>
                                        <button className="add-user-btn" onClick={showModal}>
                                            Add User
                                        </button>
                                    </div>
                                </div>
                            </div>

                        )}

                        <div className="tab-content">
                            {activeTab === "user-management" ? (
                                showInitialLoading ? (
                                    <div className="loading-container">
                                        <div className="spinner-loader"></div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="ag-grid-wrapper">
                                            <AgGridReact
                                                rowData={tableData}
                                                columnDefs={columnDefs}
                                                defaultColDef={defaultColDef}
                                                serverSideStoreType="partial"
                                                cacheBlockSize={pageSize}
                                                maxBlocksInCache={10}
                                                pagination={true}
                                                paginationPageSize={pageSize}
                                                onGridReady={onGridReady}
                                                rowSelection="multiple" // Enable row selection
                                                onSelectionChanged={onSelectionChanged}
                                                onFilterChanged={onFilterChanged}
                                                className="user-management-ag-grid"
                                                suppressCellFocus={true}
                                                domLayout="autoHeight"
                                                animateRows={true}
                                                groupDisplayType="multipleColumns"
                                                suppressHorizontalScroll={true}
                                                noRowsOverlayComponent={noRowsOverlayComponent}
                                                tooltipShowDelay={0}
                                            />
                                        </div>
                                        <>
                                            {false && <ProfileImageUploader
                                                onImageUpdate={handleImageUpdate}
                                                resetOnUnmount={true}
                                            />}
                                        </>

                                        <div style={{ display: "flex", alignItems: "center", backgroundColor: "white" }}>
                                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
                                                <div className="footer" style={{ textAlign: "right", padding: "10px", fontFamily: "Inter" }}>
                                                    Total users:{" "}
                                                    <span style={{ fontWeight: 700, fontSize: "13px" }}>
                                                        {displayedRowCount !== null && displayedRowCount !== tableData.length
                                                            ? `${displayedRowCount} of ${tableData.length}`
                                                            : tableData.length}
                                                    </span>
                                                </div>
                                            </div>
                                            <img
                                                src={PaginationPrevious}
                                                onClick={handlePrevious}
                                                alt="Less Than"
                                                style={{
                                                    height: "18px",
                                                    width: "18px",
                                                    opacity: !pageMeta?.hasPreviousPage ? 0.5 : 1,
                                                    cursor: pageMeta?.hasPreviousPage ? "pointer" : "not-allowed"
                                                }}
                                            />
                                            <span style={{ margin: "0 10px", }}>
                                                Page <span style={{ fontWeight: "bold" }}>{currentPage}</span> of <span style={{ fontWeight: "bold" }}>{totalPages}</span>
                                            </span>
                                            <img
                                                src={PaginationNext}
                                                onClick={handleNextt}
                                                alt="Greater Than"
                                                style={{
                                                    height: "18px",
                                                    width: "18px",
                                                    opacity: !pageMeta?.hasNextPage ? 0.5 : 1,
                                                    cursor: pageMeta?.hasNextPage ? "pointer" : "not-allowed"
                                                }}
                                            />
                                        </div>
                                    </>
                                )
                            ) : (
                                <div className="product-configuration"></div>
                            )}
                        </div>
                    </>
                </TabPane>
            </Tabs>

            <Modal title="User Registration Form" open={isModalVisible} onCancel={handleCancel} footer={null} width={700} centered>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <a
                            style={{
                                fontWeight: step === 0 ? 'bold' : 'normal',
                                color: step === 0 ? '#d32f2f' : 'rgb(188, 188, 188)', // Active: Red, Inactive: Blue
                            }}
                            onClick={() => setStep(0)}
                        >
                            1. User Basic Data
                        </a>

                    </Breadcrumb.Item>

                    <Breadcrumb.Item>
                        <a
                            // onClick={() => setStep(1)}
                            style={{
                                fontWeight: step === 1 ? 'bold' : 'normal',
                                color: step === 1 ? '#d32f2f' : 'rgb(188, 188, 188)', // Active: Red, Inactive: Blue

                            }}
                        >
                            2. User Work Data
                        </a>
                    </Breadcrumb.Item>
                </Breadcrumb>

                <Form form={form} layout="vertical" onSubmit={(e) => e.preventDefault()}>
                    {step === 0 ? (
                        <>
                            <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>

                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className="required-label">Employee ID</label>
                                    <TextInputField
                                        name="employeeid"
                                        value={formData.employeeid || ""}
                                        placeholder="Employee ID"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexAlphaNumeric}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleNext(e)}
                                    />
                                    {touched.employeeid && errors.employeeid && (
                                        <div className="createClientErrors">{errors.employeeid}</div>
                                    )}
                                </Col>

                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className={loginConfig.emailLogin && !loginConfig.numberLogin ? "required-label" : ""}>
                                        Employee Mail ID{loginConfig.emailLogin && !loginConfig.numberLogin}
                                    </label>
                                    <TextInputField
                                        name="employeeMailId"
                                        value={formData.employeeMailId}
                                        placeholder="Employee Mail ID"
                                        feedbackMessage="Please enter a valid email address."
                                        // validationRegex={emailRegex}
                                        onChange={handleInputChange}
                                    />
                                    {touched.employeeMailId && errors.employeeMailId && (
                                        <div className="createClientErrors">{errors.employeeMailId}</div>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className="required-label">First Name</label>
                                    <TextInputField
                                        name="firstName"
                                        value={formData.firstName}
                                        placeholder="First Name"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexOnlyAlpha}
                                        onChange={handleInputChange}
                                    />
                                    {touched.firstName && errors.firstName && (
                                        <div className="createClientErrors">{errors.firstName}</div>
                                    )}
                                </Col>
                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className="required-label">Last Name</label>
                                    <TextInputField
                                        name="lastName"
                                        value={formData.lastName}
                                        placeholder="Last Name"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexOnlyAlpha}
                                        onChange={handleInputChange}
                                    />
                                    {touched.lastName && errors.lastName && (
                                        <div className="createClientErrors">{errors.lastName}</div>
                                    )}
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>

                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className="required-label">Gender</label><br />
                                    <SelectDropdown
                                        options={genderOptions}
                                        className="custom-select"
                                        placeholder="Select Gender"
                                        value={genderOptions.find(option => option.value === formData.gender) || null} // Ensure no undefined access
                                        onChange={(selectedOption) =>
                                            handleInputChange({ target: { name: "gender", value: selectedOption.value } })
                                        }
                                        isSearchable
                                    />
                                    {touched.gender && errors.gender && (
                                        <div className="createClientErrors">{errors.gender}</div>
                                    )}
                                </Col>

                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className="required-label">Date of Birth</label>
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        placeholder="Date of Birth"
                                        value={formData.dateOfBirth ? dayjs(formData.dateOfBirth, "YYYY-MM-DD") : null}
                                        disabledDate={(current) => {
                                            // Disable dates after 18 years ago
                                            return current && current > dayjs().subtract(18, "year").endOf("day");
                                        }}
                                    />
                                    {touched.dateOfBirth && errors.dateOfBirth && (
                                        <div className="createClientErrors">{errors.dateOfBirth}</div>
                                    )}
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label>Highest Education Qualification</label>
                                    <TextInputField
                                        name="highestEducationQualification"
                                        value={formData.highestEducationQualification}
                                        placeholder="Highest Education Qualification"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexOnlyAlpha}
                                        onChange={handleInputChange}
                                    />
                                    {touched.highestEducationQualification && errors.highestEducationQualification && (
                                        <div className="createClientErrors">{errors.highestEducationQualification}</div>
                                    )}
                                </Col>
                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label>Previous Employer</label>
                                    <TextInputField
                                        name="previousEmployer"
                                        value={formData.previousEmployer}
                                        placeholder="Previous Employer"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexAlphaNumeric}
                                        onChange={handleInputChange}
                                    />
                                    {touched.previousEmployer && errors.previousEmployer && (
                                        <div className="createClientErrors">{errors.previousEmployer}</div>
                                    )}
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>

                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label></label>Previous Experience (Months)
                                    <TextInputField
                                        name="previousExperience"
                                        value={formData.previousExperience}
                                        placeholder="Previous Experience (Months)"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexAmount}
                                        onChange={(e) => handleInputChange(e, "previousExperience")}
                                    />
                                    {touched.previousExperience && errors.previousExperience && (
                                        <div className="createClientErrors">{errors.previousExperience}</div>
                                    )}
                                </Col>

                                <Col sm={12} xs={23} md={11} lg={12}>
                                    <label className={loginConfig.numberLogin && !loginConfig.emailLogin ? "required-label" : ""}>
                                        Phone Number{loginConfig.numberLogin && !loginConfig.emailLogin}
                                    </label>
                                    <TextInputField
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        placeholder="Phone Number"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexMobileNo}
                                        maxLength={10}
                                        onChange={handleInputChange}
                                    />
                                    {touched.phoneNumber && errors.phoneNumber && (
                                        <div className="createClientErrors">{errors.phoneNumber}</div>
                                    )}
                                </Col>
                            </Row>


                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <div style={{ display: "flex" }}>
                                    <button
                                        className="global-admin-bulk-upload-button"
                                        onClick={showModalForUpload}
                                    >
                                        Bulk Upload
                                    </button>

                                    <button className="handleDownload" onClick={handleDownload} disabled={downloadLoading}>
                                        Bulk Upload Sheet
                                    </button>
                                </div>

                                {/* Right side: Next button */}
                                <div style={{ display: "flex", justifyContent: "flex-end", }}>
                                    <button className="nextButton" onClick={(e) => handleNext(e)}>Next</button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                                {formDataList?.map((formData, index, item) => (
                                    <div key={index} style={{ borderBottom: "1px solid #ccc", paddingBottom: "20px", marginBottom: "20px" }}>
                                        <Row gutter={[16, 16]} style={
                                            {
                                                marginBottom: "-5px"
                                            }
                                        }>
                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">Employment Type</label>

                                                <Form.Item
                                                    name={["formDataList", index, "fullTimeConsultant"]}
                                                    rules={[
                                                        { required: true, message: "This field is required!" }
                                                    ]}
                                                >
                                                    <SelectDropdown
                                                        options={employementOptions}
                                                        placeholder="Select Employment Type"
                                                        value={formDataList[index]?.fullTimeConsultant || null} // Ensure a valid value
                                                        onChange={(selectedOption) => {
                                                            const updatedList = [...formDataList];
                                                            updatedList[index] = {
                                                                ...updatedList[index],
                                                                fullTimeConsultant: selectedOption.value
                                                            };
                                                            setFormDataList(updatedList);
                                                            form.setFieldsValue({
                                                                fullTimeConsultant: selectedOption.value
                                                            });
                                                        }}
                                                        isSearchable
                                                    />
                                                </Form.Item>

                                            </Col>

                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">Date of Joining</label>

                                                <Form.Item
                                                    name={["formDataList", index, "dateOfJoining"]}
                                                    rules={[{ required: true, message: "Date of Joining is required!" }]}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        placeholder="Date of Joining"
                                                        onChange={(date) => handleListDateChange(index, "dateOfJoining", date)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} style={
                                            {
                                                marginBottom: "-5px"
                                            }
                                        }>
                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">Current Designation</label>

                                                <Form.Item
                                                    name={["currentDesignation"]}
                                                    rules={[{ required: true, message: "Designation is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        options={designationOptions}
                                                        placeholder="Current Designation"
                                                        // isDisabled={!selectedRole}
                                                        // isLoading={designationLoading}
                                                        onChange={handleDesignationChange}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">Current Branch</label>

                                                <Form.Item
                                                    name={["formDataList", index, "currentBranch"]}
                                                    rules={[
                                                        { required: true, message: "Branch is required!" },
                                                        {
                                                            pattern: validationRegexOnlyAlpha,
                                                            message: "Only alphabets are allowed!",
                                                        },
                                                    ]}
                                                >
                                                    <TextInputField
                                                        placeholder="Current Branch"
                                                        feedbackMessage="Please input the current branch."
                                                        onChange={(e) => handleInputChange(e, "currentBranch", index)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} style={
                                            {
                                                marginBottom: "-5px"
                                            }
                                        }>
                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">State</label>

                                                <Form.Item
                                                    name={["formDataList", index, "state"]}
                                                    rules={[{ required: true, message: "State is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        options={stateOptions}
                                                        placeholder="Select State"
                                                        isLoading={stateLoading}
                                                        onChange={handleStateChange}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">City</label>

                                                <Form.Item
                                                    name={["formDataList", index, "city"]}
                                                    rules={[{ required: true, message: "City is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        options={cityOptions}
                                                        placeholder="Select City"
                                                        isDisabled={!selectedState}
                                                        isLoading={citiesLoading}
                                                        onChange={handleCityChange}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} style={
                                            {
                                                marginBottom: "-5px"
                                            }
                                        }>
                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">Zone</label>
                                                <Form.Item
                                                    name={["formDataList", index, "zone"]}
                                                    rules={[{ required: true, message: "Zone is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        options={userTypeOptions}
                                                        placeholder="Zone"
                                                        onChange={(selectedOption) => handleZoneChange(selectedOption, index)}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label>Select Manager</label>
                                                <Form.Item
                                                    name={["formDataList", index, "employeeIdOfManager"]}
                                                >
                                                    <SelectDropdown
                                                        options={managerOptions}
                                                        placeholder="Select Manager"
                                                        onChange={(selectedOption) => handleManagerSelect(selectedOption, index)}
                                                        isSearchable
                                                        isClearable
                                                        isLoading={managersListLoading}
                                                        onInputChange={(inputValue) => setManagerSearchTerm(inputValue)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} style={
                                            {
                                                marginBottom: "x"
                                            }
                                        }>
                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className={formDataList[index]?.employeeIdOfManager ? "required-label" : ""}>Date of Reporting</label>
                                                <Form.Item
                                                    name={["formDataList", index, "dateOfReporting"]}
                                                    dependencies={[["formDataList", index, "employeeIdOfManager"]]}
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const managerId = getFieldValue(["formDataList", index, "employeeIdOfManager"]);
                                                                if (managerId && !value) {
                                                                    return Promise.reject(new Error("Date of Reporting is required when Manager is selected!"));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        placeholder="Date of Reporting"
                                                        onChange={(date) => handleListDateChange(index, "dateOfReporting", date)}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label>Employee ID of Manager</label>
                                                <Form.Item>
                                                    <TextInputField
                                                        placeholder="Employee ID of Manager"
                                                        value={selectedManagerEmployeeId || "No Manager Selected"}
                                                        disabled
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
                                            <Col sm={12} xs={23} md={11} lg={12}>
                                                <label className="required-label">User Type</label>
                                                <Form.Item
                                                    name={["formDataList", index, "userType"]}
                                                    rules={[{ required: true, message: "User Type is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        options={userTypesOptions}
                                                        placeholder="Select User Type"
                                                        value={userTypesOptions.find(option => option.value === formDataList[index]?.userType) || null}
                                                        onChange={(selectedOption) => handleUserTypeChange(selectedOption, index)}
                                                        isSearchable
                                                    />
                                                </Form.Item>
                                                {touched[`${index}-userType`] && errors[`${index}-userType`] && (
                                                    <div className="createClientErrors">{errors[`${index}-userType`]}</div>
                                                )}
                                            </Col>
                                        </Row>
                                        {index > 0 && (
                                            <button
                                                className="user-management-cancel-button"
                                                onClick={() => removeUserFields(index)}
                                                style={{ marginTop: "10px", backgroundColor: "#d32f2f", color: "white", display: "flex", justifySelf: "end", alignItems: "center" }}
                                            >
                                                Remove User
                                            </button>
                                        )}
                                    </div>
                                ))}

                                <div className="global-admin-modal-footer-user-management" >
                                    <button className="user-management-cancel-button" onClick={handleCancel}>
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="user-management-save-button"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent default refresh behavior
                                            const allFields = Object.keys(form.getFieldsValue());
                                            const fieldsToValidate = allFields.filter(field => field !== "branch" && field !== "cityName" && field !== "designation" && field !== "employeeType" && field !== "employeeIds" && field !== "joiningDate" && field !== "reportingDate" && field !== "stateName" && field !== "zone");
                                            form.validateFields()
                                                .then((values) => {
                                                    handleSubmit();
                                                })
                                                .catch((errorInfo) => {
                                                    console.log("Validation Failed:", errorInfo);
                                                });
                                        }}
                                        disabled={addUsersLoading}
                                        style={{ opacity: addUsersLoading ? 0.7 : 1, cursor: addUsersLoading ? 'not-allowed' : 'pointer' }}
                                    >
                                        {addUsersLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Save'}
                                    </button>
                                </div>
                            </Form>
                        </>
                    )}
                </Form>
            </Modal>

            <Modal
                title="Bulk Lead Upload"
                open={isModalVisibleForUpload}
                onCancel={handleCancelUpload}
                footer={null}
                width={600}
                centered
                destroyOnClose
            >
                <div
                    style={{
                        padding: "20px",
                        textAlign: "center",
                        border: "2px dashed #ccc",
                        borderRadius: "8px",
                        cursor: "pointer"
                    }}
                    onClick={() => document.getElementById("fileUpload").click()} // Opens file input
                >
                    <div className="uploadIconOfAddUser">
                        <img src={BulkUploadFiles} alt="Upload Icon" />
                    </div>

                    <p style={{ fontSize: "16px", fontFamily: "Inter" }}>
                        Drag & Drop files or <span style={{ color: "#c81e1e" }}>Browse</span>
                    </p>
                    <p style={{ color: "#666", fontSize: "12px", marginTop: "10px" }}>
                        Supported formats: xlsx
                    </p>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        id="fileUpload"
                        style={{ display: "none" }}
                        accept=".xlsx"
                        onChange={(e) => setFile(e.target.files[0])} // Store file on selection
                    />
                </div>

                {/* Show selected file name */}
                {file && (
                    <p style={{ textAlign: "center", marginTop: "10px", fontSize: "14px" }}>
                        File Selected: {file.name}
                    </p>
                )}

                {/* Upload button */}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button
                        onClick={handleUpload}
                        disabled={!file}
                        style={{
                            background: "#FAC9CA",
                            color: "#9B9C9C",
                            border: "none",
                            padding: "8px 20px",
                            borderRadius: "4px",
                            transition: "background 0.3s ease-in-out",
                            cursor: file ? "pointer" : "not-allowed",
                            fontWeight: "500",
                            background: file ? "#AD0101" : "#FAC9CA", // Red when active, light pink when disabled
                            color: file ? "#FFF" : "#9B9C9C",
                        }}
                    >
                        Upload File
                    </button>
                </div>
            </Modal>

            <UploadModal
                title="Performance Upload"
                open={isModalVisibleForPerformanceUpload}
                onCancel={handleCancelPerformanceUpload}
                accountId={accountId}
                roleId={roleId}
                mutation={bulkUploadPerformance} // Replace with actual performance upload mutation if different
                onSuccess={handlePerformanceUploadSuccess}
            />
        </div >
    );
};

export default AdminUserManagement;